// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - SDKAreaImport
export class SDKAreaImport {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Markdown import
    /**
     * Validate documentation MDX-lite without writing.
     *
     * This is an optional preflight for inspecting unsupported content.
     * `writeMarkdownToPage` runs the same validation before updating the page.
     * See `docs/markdown-import.md` for the supported syntax.
     *
     * @param from - Remote version to validate against
     * @param markdown - Markdown / MDX-lite source
     */
    async validateMarkdown(from, markdown) {
        return this.dataCore.validateDocumentationMarkdown(from.designSystemId, from.versionId, markdown);
    }
    /**
     * Validate documentation MDX-lite and replace the target page's content.
     *
     * Invalid input rejects without changing the page. Use `validateMarkdown` when
     * validation needs to run separately from the write.
     * See `docs/markdown-import.md` for the supported syntax.
     *
     * @param from - Remote version to write into
     * @param pageId - Target documentation page id
     * @param markdown - Markdown / MDX-lite source
     */
    async writeMarkdownToPage(from, pageId, markdown) {
        return this.dataCore.writeDocumentationMarkdownToPage(from.designSystemId, from.versionId, pageId, markdown);
    }
}
